import logging from "./utils/logging";

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/service-worker.js");
      logging.info("Service worker registered", reg.scope);

      // Check for updates periodically
      setInterval(() => reg.update(), 60 * 60 * 1000); // hourly
    } catch (err) {
      logging.warn("Service worker registration failed", err);
    }
  });
}

export function unregisterServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready.then((reg) => reg.unregister());
}
